import { NavLink, useHistory } from "react-router-dom";

import {
  Breadcrumb,
  EmailLink,
  Link,
} from "@transfr-inc/dashboard-components";
import { PageHeader } from "@transfr-inc/dashboard-components/layouts";

import { ArchivedBadge } from "@components/custom/content";
import {
  createDashboardLink,
  createUsersLink,
} from "@lib/utils/navigation.utils";
import { Role } from "@models/role";
import { useFeatures, useRole } from "@queries";

import "./trainee.header.scss";

export function TraineeHeader({
  trainee,
  organization,
  breadcrumbLabel,
  path,
  children,
}) {
  const history = useHistory();
  const isNewWindow = history.length === 1;

  const { firstName, lastName, username, email, isArchived } = trainee;
  const { name: orgName, code } = organization;
  const fullName = `${firstName} ${lastName}`;

  const role = useRole();
  const features = useFeatures();

  const hasMultiOrgAccess = features?.superAdminsTabEnabled;
  const dashboardLink = createDashboardLink({
    orgCode: hasMultiOrgAccess ? code : undefined,
    search: {
      from: `Trainee`,
    },
  });

  const subTitle = (
    <ul className="metadata">
      {username && <li>{username}</li>}
      {email && (
        <li>
          <EmailLink to={email} />
        </li>
      )}
      <li>
        {role != Role.STUDENT.id ? (
          <Link routerComponent={NavLink} to={dashboardLink}>
            {orgName}
          </Link>
        ) : (
          orgName
        )}
      </li>
      {isArchived && (
        <li>
          <ArchivedBadge />
        </li>
      )}
    </ul>
  );

  const onBreadcrumbClick = () => {
    if (path) {
      history.push(path);
    } else if (isNewWindow) {
      history.push(createUsersLink());
    } else {
      history.goBack();
    }
  };

  return (
    <PageHeader
      className="trainee-detail-header"
      title={fullName}
      subTitle={subTitle}
      breadcrumb={
        role != Role.STUDENT.id && (
          <Breadcrumb
            label={isNewWindow ? "All Users" : breadcrumbLabel}
            onClick={onBreadcrumbClick}
          ></Breadcrumb>
        )
      }
    >
      {children}
    </PageHeader>
  );
}
